import React, {useState} from 'react'
import './paymentstyle.css'
import logocard from '../images/mc_symbol.svg'
import check from '../images/icon-complete.svg'

const Paymentsystem = () => {

    const [Confirm, setConfirm] = useState(false);

    const [Name, setName] = useState("");

    const [Number, setNumber] =  useState("");

    const [Expiry, setExpiry] = useState("");

    const [Cvc, setCvc] = useState("");

  return (
    <div className='contents'>
    <div className='headpay w-100'>
        <div className='maindiv d-flex'>         
                <div className='cards col-3 mt-5 mx-5'>
                <article className='front-card p-5 d-flex flex-column justify-content-between'>
                    <img className='mt-1 mx-2' src={logocard} alt="" width={100}/>
                    <div className='details-card'>
                        <h2 className='fw-bolder mb-5 mt-3 text-white'>{Number}</h2>

                        <ul className='d-flex align-items-center justify-content-between list-unstyled'>
                            <li><h6 className='fw-bold text-uppercase text-white'>{Name}</h6></li>
                            <li><h6 className='fw-bold text-white'>{Expiry}</h6></li>
                        </ul>
                        </div>
                </article>
                <div>
                <article className='back-card mt-3 position-relative p-5'>
                    <h6 className='position-absolute text-white'>{Cvc}</h6>
                </article>
                </div>
            </div>
            <div className='col-9 mt-5'>
                <div className='form1 p-5 '>
                {!Confirm && <form className='Form mt-5 w-75'>
        <label htmlFor='Cardholder_name'>Cardholder's Name:</label>
        <input 
        type='text' 
        name='Cardholder_name' 
        id='Cardholder_name' 
        placeholder='e.g. Jane Smith:' 
        value={Name} 
        onChange={(e)=> setName(e.target.value)}
        required>
        </input>
        <label htmlFor='Card_number'>Card number:</label>
        <input type='number' 
        name='Card_number' 
        id='Card_number' 
        placeholder='1234 1234 ....'
        value={Number.replace(/\s/g, "").replace(/(\d{19})/g, "$1 ").trim()}
        maxLength={19}
        onChange={(e) => setNumber(e.target.value)}
        required>
        </input>

        <div className='w-75'>
        <article className='number-card d-flex align-items-center justify-content-center '>
            <div>
                <label htmlFor='Expiry_date'className='mx-3 '>Expiry:</label>
        <input className='w-75'
        type='month' 
        name='Expiry_date' 
        id='Expiry_date' 
        placeholder='00/00' 
        value={Expiry}
        onChange={(e) => setExpiry(e.target.value)}
        required></input>
        </div>
            <div>
                <label htmlFor='Cvc' className='mx-3'>CVC: </label>
        <input className='w-100'
        type='number' 
        name='Cvc' 
        id='Cvc' 
        placeholder='123' 
        maxLength={3}
        min={1}
        value={Cvc}
        onChange={(e) => setCvc(e.target.value)}
        required></input>
        </div>
        </article>
        </div>
        <button name='button' onClick={()=>setConfirm(true)} className='Bbtn align-items-center mt-5'>Submit</button>
        </form>}
        {Confirm && <ThankYou setConfirm={setConfirm}/>}
            </div>
            </div>
        </div>
    </div>
    </div>
    
)
};

function ThankYou({setConfirm}) {
    return(
    <>
    <div className='thankyou_card'>
    <img src={check} alt="" className=' d-block mx-auto' />
    <h1 className='mb-3 mt-2 text-center'>Thank you!</h1>
    <p className=' text-center'>We've added your card details.</p>
    <button name='button' onClick={() => setConfirm(false)} className='Bbtn d-block mx-auto align-items-center mt-4'>Continue</button>
    </div>
    </>
    )
}

export default Paymentsystem